import * as Sentry from '@sentry/react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { SignInPage } from '~/pages/auth/signin';
import { SignUpPage } from '~/pages/auth/signup';
import { appRoute } from '~/router/app';

export const router = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)([
  appRoute,
  {
    path: 'app/signin',
    element: <SignInPage />
  },
  {
    path: 'app/signup/:handle',
    element: <SignUpPage />
  },
  {
    path: 'signin',
    element: <Navigate to="/app/signin" replace />
  },
  {
    path: '',
    element: <Navigate to="/app" replace />
  }
]);
